var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeFloatingPanel,
          expression: "closeFloatingPanel",
        },
      ],
      staticClass: "sdp",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "button",
        {
          ref: "trigger",
          staticClass: "depth-action-btn sdp__trigger",
          class: { active: _vm.isOpen || _vm.depth.rows > 1 },
          attrs: { title: "Shelf depth", type: "button" },
          on: { click: _vm.toggleFloatingPanel },
        },
        [
          _c(
            "svg",
            {
              staticClass: "lucide lucide-layers h-3 w-3",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "sdp__badge" }, [
            _vm._v(_vm._s(_vm.depth.rows)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "sdp-panel" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                ref: "panel",
                staticClass: "sdp__panel",
                style: _vm.floatingPanelStyle,
              },
              [
                _vm._l(_vm.controls, function (control) {
                  return _c(
                    "div",
                    { key: control.key, staticClass: "sdp__control" },
                    [
                      _c("div", { staticClass: "sdp__label" }, [
                        _c("span", [_vm._v(_vm._s(control.label))]),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.formatValue(control))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.draft[control.key],
                            expression: "draft[control.key]",
                            modifiers: { number: true },
                          },
                        ],
                        attrs: {
                          type: "range",
                          min: control.min,
                          max: control.max,
                          step: control.step,
                        },
                        domProps: { value: _vm.draft[control.key] },
                        on: {
                          input: _vm.emitChange,
                          __r: function ($event) {
                            _vm.$set(
                              _vm.draft,
                              control.key,
                              _vm._n($event.target.value)
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "sdp__footer" }, [
                  _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("apply-all", _vm.depth)
                        },
                      },
                    },
                    [_vm._v("\n          Apply to all shelves\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    { attrs: { type: "button" }, on: { click: _vm.reset } },
                    [_vm._v("\n          Reset\n        ")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sdp__reset-all" }, [
                  _c(
                    "button",
                    {
                      attrs: {
                        type: "button",
                        title: "Reset depth settings for all shelves",
                      },
                      on: { click: _vm.resetAll },
                    },
                    [_vm._v("\n          Reset\n        ")]
                  ),
                ]),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }